import React, { useCallback, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { ArrayParam, useQueryParam, withDefault } from 'use-query-params'

import { SlotPlace } from 'modules/SlotsRoot/redefinitions'
import { toFilterCategoryKey } from 'modules/SlotsRoot/utils/categoryName'

export const slotsCategoryFilterQuery = 'categories'
export const slotsProviderFilterQuery = 'providers'

const normalizeCategoriesParam = (categories: (string | null)[] | null | undefined): string[] =>
  (categories ?? [])
    .filter((category): category is string => Boolean(category))
    .map(category => toFilterCategoryKey(category))

const withQueryParams = (WrappedComponent: React.FC<any>) => (props: any) => {
  const { place } = useParams<{ place: SlotPlace }>()
  const [selectedProviders, setSelectedProviders] = useQueryParam(slotsProviderFilterQuery, withDefault(ArrayParam, []))
  const [selectedCategoriesRaw, setSelectedCategoriesRaw] = useQueryParam(
    slotsCategoryFilterQuery,
    withDefault(ArrayParam, []),
  )
  const [searchString, setSearchString] = useState('')

  const selectedCategories = useMemo(
    () => normalizeCategoriesParam(selectedCategoriesRaw),
    [selectedCategoriesRaw],
  )

  const setSelectedCategories = useCallback(
    (categories: (string | null)[] | null | undefined) => {
      setSelectedCategoriesRaw(normalizeCategoriesParam(categories))
    },
    [setSelectedCategoriesRaw],
  )

  return (
    <WrappedComponent
      {...props}
      place={place}
      filters={{
        selectedProviders,
        setSelectedProviders,
        selectedCategories,
        setSelectedCategories,
        searchString,
        setSearchString,
      }}
    />
  )
}

export default withQueryParams
